export default {
  data() {
    return {
      interiorLabel: this.$t("message.WithInterior"),
    }
  },
  computed: {
    interior: {
      get() {
        let value = this.$store.getters.filters.interior

        this.$nextTick(function () {
          if(value) {
            let tag = {
              value: this.interiorLabel,
              key  : 'interior',
            }

            this.$store.dispatch('setTags', {
              interior: tag
            })
          }
        })

        return value
      },
      set(value) {
        let tag = {
          value: this.interiorLabel,
          key  : 'interior',
        }

        if (value) {
          this.$store.dispatch('setFilters', {'p':1, interior: value.toString()}).then(() => {
            this.$store.dispatch('setTags', {
              interior: tag
            })
          })
        } else {
          this.$store.dispatch('removeTag', tag).then(() => {
          })
        }
      },
    }
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/FilterInteriorMix.js
// module id = null
// module chunks = 